import { render } from "./PurchaseTableSpecialist.vue?vue&type=template&id=31b643dc"
import script from "./PurchaseTableSpecialist.vue?vue&type=script&lang=js"
export * from "./PurchaseTableSpecialist.vue?vue&type=script&lang=js"

import exportComponent from "/home/ubuntu/apps/crm/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__